export default __webpack_public_path__ + "images/EZ.7e80ba7.png";